import { e社員区分 } from "../../constant/enum/syain"
import { e部所権限コード, 権限コード } from "../../constant/kengenCode"
import { TLoginUserInfo } from "../../service/auth/TAuth"

/**
 * 車輌所属画面の車輌異動ボタンの使用権限判定
 * @param userInfo
 * @returns true:使用可能 false:使用不可
 */
const 車輌異動ボタンの権限判定 = (userInfo: TLoginUserInfo) => {
  let 権限 = false
  let has部所権限
  let has社員区分権限

  // 部所権限をチェック
  switch (userInfo.部所権限コード) {
    case 権限コード.車輌マスタ登録.安全:
    case 権限コード.車輌マスタ登録.車輌:
    case 権限コード.車輌マスタ登録.本営:
    case 権限コード.車輌マスタ登録.大川:
    case 権限コード.車輌マスタ登録.金彰:
      has部所権限 = true
      break
    default:
      has部所権限 = false
      break
  }

  // 社員区分をチェック
  switch (userInfo.社員区分コード) {
    case e社員区分.事務員:
    case e社員区分.事務員管理職:
    case e社員区分.運行部員管理職:
    case e社員区分.役員:
    case e社員区分.システム管理者:
      has社員区分権限 = true
      break
    default:
      has社員区分権限 = false
      break
  }

  // 部所権限、社員区分権限ともに問題ない場合、使用可能
  if (has部所権限 && has社員区分権限) {
    権限 = true
  }

  // 読取専用フラグとして返却する
  return !権限
}

/**
 * 備品在庫一覧画面の削除ボタンの使用権限判定
 * @param userInfo
 * @returns true:使用可能 false:使用不可
 */
const 備品在庫削除ボタンの権限判定 = (userInfo: TLoginUserInfo) => {
  let 権限 = false
  let has社員区分権限

  // 社員区分をチェック
  switch (userInfo.社員区分コード) {
    case e社員区分.システム管理者:
      has社員区分権限 = true
      break
    default:
      has社員区分権限 = false
      break
  }

  // 使用権限を設定
  if (has社員区分権限) {
    権限 = true
  }

  // 使用権限として返却する
  return 権限
}

/**
 * 有休管理画面の有休付与と変更ボタンの使用権限判定
 * @param userInfo
 * @returns true:使用可能 false:使用不可
 */
const 有休管理画面の有休付与と変更ボタンの使用権限判定 = (
  userInfo: TLoginUserInfo
) => {
  let has部所権限
  let has社員区分権限

  // 部所権限をチェック
  switch (userInfo.部所権限コード) {
    case e部所権限コード.人事:
      has部所権限 = true
      break
    default:
      has部所権限 = false
      break
  }

  // 社員区分をチェック
  switch (userInfo.社員区分コード) {
    default:
      has社員区分権限 = true
      break
  }

  // 部所権限、社員区分権限ともに問題ない場合、使用可能
  return has部所権限 && has社員区分権限
}

/**
 * 有休管理画面の他部所閲覧権限判定
 * @param userInfo
 * @returns true:使用可能 false:使用不可
 */
const 有休管理画面の他部所閲覧権限判定 = (userInfo: TLoginUserInfo) => {
  let has部所権限
  let has社員区分権限

  // 部所権限をチェック
  switch (userInfo.部所権限コード) {
    case e部所権限コード.人事:
      has部所権限 = true
      break
    default:
      has部所権限 = false
      break
  }

  // 社員区分をチェック
  switch (userInfo.社員区分コード) {
    case e社員区分.システム管理者:
      has社員区分権限 = true
      break
    default:
      has社員区分権限 = false
      break
  }

  // 部所権限、社員区分権限どちらかで許可されている場合、使用可能
  return has部所権限 || has社員区分権限
}

/**
 * 乗務員運行月報の集計実行ボタンの使用権限判定
 * @param userInfo
 * @returns true:使用可能 false:使用不可
 */
const 乗務員運行月報の集計実行ボタンの使用権限判定 = (
  userInfo: TLoginUserInfo
) => {
  let has部所権限
  let has社員区分権限

  // 部所権限をチェック(大川TPのみ利用不可)
  switch (userInfo.部所権限コード) {
    case e部所権限コード.大TP:
      has部所権限 = false
      break
    default:
      has部所権限 = true
      break
  }

  // 社員区分をチェック（全区分で使用可）
  switch (userInfo.社員区分コード) {
    default:
      has社員区分権限 = true
      break
  }

  // 部所権限、社員区分権限ともに問題ない場合、使用可能
  return has部所権限 && has社員区分権限
}

/**
 * 出勤簿変更可能権限判定
 * @param userInfo
 * @returns true:使用可能 false:使用不可
 */
const 出勤簿変更可能権限判定 = (userInfo: TLoginUserInfo) => {
  let has部所権限
  let has社員区分権限

  // 部所権限をチェック
  switch (userInfo.部所権限コード) {
    case e部所権限コード.人事:
      has部所権限 = true
      break
    default:
      has部所権限 = false
      break
  }

  // 社員区分をチェック
  switch (userInfo.社員区分コード) {
    case e社員区分.システム管理者:
      has社員区分権限 = false
      break
    default:
      has社員区分権限 = false
      break
  }

  // 部所権限、社員区分権限いずれかを持つ場合、使用可能
  return has部所権限 || has社員区分権限
}

const kengenUtil = {
  車輌異動ボタンの権限判定,
  備品在庫削除ボタンの権限判定,
  有休管理画面の有休付与と変更ボタンの使用権限判定,
  有休管理画面の他部所閲覧権限判定,
  乗務員運行月報の集計実行ボタンの使用権限判定,
  出勤簿変更可能権限判定,
}

export default kengenUtil
